import { DefaultButton, PrimaryButton, Stack } from "@fluentui/react"

const stackTokens = { childrenGap: 10 };

const goBack = () => { }
const goRegister = () => { }

export const ButtonForm = ({ back = goBack, register = goRegister, disabledRegister = false }) => {
    return (
        <>
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12" style={{
                        display: 'flex',
                        justifyContent: 'flex-end'
                    }}>
                        <Stack horizontal tokens={stackTokens}>
                            <DefaultButton text="Cancelar" onClick={back} allowDisabledFocus />
                            <PrimaryButton
                                text='Registrar'
                                onClick={register}
                                allowDisabledFocus
                                disabled={disabledRegister} />
                        </Stack>
                    </div>
                </div>
            </div>
        </>
    )
}

export const ButtonFormFilter = ({ back = goBack, register = goRegister, disabledRegister = false }) => {
    return (
        <>
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12" style={{
                        display: 'flex',
                        justifyContent: 'flex-end'
                    }}>
                        <Stack horizontal tokens={stackTokens}>
                            <DefaultButton text="Limpiar" onClick={back} allowDisabledFocus />
                            <PrimaryButton
                                text='Buscar'
                                onClick={register}
                                allowDisabledFocus
                                disabled={disabledRegister} />
                        </Stack>
                    </div>
                </div>
            </div>

        </>
    )
}

export const ButtonFormPanel = ({ back = goBack, register = goRegister, disabledRegister = false, textRegister = 'Registrar', textCancel = 'Cancelar' }) => {
    return (
        <>
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12"
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            justifyItems: "center",
                            height: "5%",
                            padding: "0 20px",
                        }}>
                        <div style={{ display: "flex" }}>
                            <PrimaryButton
                                text={textRegister}
                                onClick={register}
                                allowDisabledFocus
                                disabled={disabledRegister} />
                        </div>
                        <div style={{ display: "flex" }}>
                            <DefaultButton
                                text={textCancel}
                                onClick={back}
                                allowDisabledFocus />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
